var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownstreamLeasedAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38875 0.0528564H5.74422V3.25772H4.98756V1.32043H4.34303V3.25772H3.45294V21.3555H1.93359V22H11.0217V3.25772H6.38875V0.0528564ZM10.3771 21.3555H4.09747V3.90225H10.3771V21.3555Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2578 10.4359V20.7402H16.0405V10.4359H14.2578ZM15.396 20.0957H14.9023V11.0804H15.396V20.0957Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9102 10.4359V20.7402H13.6929V10.4359H11.9102ZM13.0483 20.0957H12.5547V11.0804H13.0483V20.0957Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79997 5.65002H4.67578V7.64438H9.79997V5.65002ZM9.15544 6.99985H5.32031V6.29456H9.15544V6.99985Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79997 8.43457H4.67578V10.4291H9.79997V8.43457ZM9.15544 9.78456H5.32031V9.0791H9.15544V9.78456Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79997 11.2194H4.67578V13.2137H9.79997V11.2194ZM9.15544 12.5692H5.32031V11.8639H9.15544V12.5692Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79997 14.0039H4.67578V15.9983H9.79997V14.0039ZM9.15544 15.3537H5.32031V14.6484H9.15544V15.3537Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79997 16.7887H4.67578V18.7831H9.79997V16.7887ZM9.15544 18.1385H5.32031V17.4332H9.15544V18.1385Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5729 9.52155L13.1758 7.40063L14.7157 5.86081H17.2125V5.21628H15.3602L16.8433 3.73335H18.3613V3.08882H17.4878L18.5048 2.07167L18.0491 1.61597L16.3641 3.30081V2.16499H15.7195V3.94534L14.3185 5.34653V3.14975H13.674V5.99106L12.5608 7.10422L11.6979 6.68796L11.418 7.26837L16.9284 9.92622V21.3554H11.558V21.9999H19.0924V21.3554H17.5729V9.52155Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7033 0.0558929C19.4691 0.0871124 13.9502 0.837891 12.5425 2.24579C11.4531 3.33495 11.1357 4.95651 11.7338 6.37683L12.3278 6.12674C11.832 4.94913 12.0951 3.60468 12.9982 2.70149C13.9549 1.74477 17.5913 1.02487 19.3659 0.75531C19.0964 2.53012 18.3766 6.16635 17.4197 7.12308C17.0404 7.50241 16.5676 7.77885 16.0523 7.9227L16.2255 8.5434C16.8474 8.37001 17.4179 8.03633 17.8754 7.57895C19.2833 6.17105 20.0341 0.652084 20.0655 0.417938L20.1212 0L19.7033 0.0558929Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78418 4.99463H8.35547V4.3501H9.78418V4.99463ZM7.92578 4.99463H7.28125V4.3501H7.92578V4.99463ZM6.85156 4.99463H6.20703V4.3501H6.85156V4.99463Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3861 7.56238L15.3446 6.91919C15.5313 6.90727 15.7146 6.87035 15.8893 6.80959L16.1009 7.41837C15.8713 7.49826 15.6308 7.54677 15.3861 7.56238ZM14.9002 7.5508C14.5932 7.51605 14.2976 7.43011 14.0215 7.29533L14.3043 6.71609C14.5141 6.81865 14.7389 6.88394 14.9725 6.91029L14.9002 7.5508ZM16.5451 7.21695L16.2267 6.65651C16.3873 6.5652 16.536 6.45157 16.6688 6.31897L17.1245 6.77467C16.9509 6.94823 16.756 7.09694 16.5451 7.21695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownstreamLeasedAssets);
export default __webpack_public_path__ + "static/media/downstreamLeasedAssets.39a3c7076c8b53aa3bc1c7629935d37d.svg";
export { ForwardRef as ReactComponent };